import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../shared/services/navigation.service';
import { Subscription } from 'rxjs';
import { ThemeService } from '../../../shared/services/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from '../../services/layout.service';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { GeneralService } from 'app/shared/services/general/general.service';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
})
export class HeaderTopComponent implements OnInit, OnDestroy {
  layoutConf: any;
  menuItems: any;
  menuItemSub: Subscription;
  permissionCheck = false;
  userName : string = ''
  egretThemes: any[] = [];
  public availableLangs = [
    {
      name: 'EN',
      code: 'en',
      flag: 'us',
    },
    {
      name: 'ES',
      code: 'es',
      flag: 'es',
    },
  ];
  currentLang = this.availableLangs[0];

  @Input() notificPanel;
  constructor(
    private layout: LayoutService,
    private navService: NavigationService,
    public themeService: ThemeService,
    public translate: TranslateService,
    public jwtAuth: JwtAuthService,
    private router: Router,
    private api: GeneralService
  ) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        // Use the final URL so redirects such as /pms -> /pms/products are
        // evaluated against the actual page being displayed.
        this.updateSideNavVisibility(event.urlAfterRedirects || event.url);
      }
    });
  }

  ngOnInit() {
    this.updateSideNavVisibility(this.router.url);

    this.layoutConf = this.layout.layoutConf;
    this.egretThemes = this.themeService.egretThemes;
    this.translate.use(this.currentLang.code);
    this.menuItemSub = this.navService.menuItems$.subscribe((res) => {
      res = res.filter(
        (item) => item.type !== 'icon' && item.type !== 'separator'
      );
      let limit = 10;
      let mainItems: any[] = res.slice(0, limit);
      if (res.length <= limit) {
        return (this.menuItems = mainItems);
      }
      let subItems: any[] = res.slice(limit, res.length - 1);
      mainItems.push({
        name: 'More',
        type: 'dropDown',
        tooltip: 'More',
        icon: 'more_horiz',
        sub: subItems,
      });
      this.menuItems = mainItems;
    });

    this.getPermissions();
    this.getProfile();
  }
  ngOnDestroy() {
    this.menuItemSub.unsubscribe();
  }
  setLang(lng) {
    this.currentLang = lng;
    this.translate.use(lng.code);
  }
  changeTheme(theme) {
    this.layout.publishLayoutChange({ matTheme: theme.name });
  }
  toggleNotific() {
    this.notificPanel.toggle();
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed',
    });
  }

  private updateSideNavVisibility(url: string): void {
    const path = url.split('?')[0].split('/').filter(Boolean);
    const section = path[0] || '';
    const sectionConfig = this.navService.plainMenu.find((item) =>
      item.url_slug === section || item.state === section
    );
    const isPmsProductList = section === 'pms' && path[1] === 'products';

    this.layout.publishLayoutChange({
      showSideNav: !!sectionConfig?.side_nav?.length,
      // PMS product listing is full-width on desktop, while its contextual
      // navigation remains available through the mobile drawer.
      desktopSideNav: !isPmsProductList,
    });
  }
  getProfile() {
    this.api.getProfileDetails().subscribe((result: any) => {
      const profile = Array.isArray(result) ? result[0] : result;
      this.userName = profile?.username || '';
      this.jwtAuth.updateUsername(profile?.username || '');
    });
  }
  getPermissions() {
    this.jwtAuth.getPermissions().subscribe((result) => {
      this.jwtAuth.updatePermimissions({
        permissions: result?.data ?? [],
        is_super_admin: result?.is_super_admin,
        user_type: result?.user_type,
      });
      if (result?.user_type == 'supplier') {
        this.menuItems = this.menuItems.filter((ae) =>
          ['PMS', 'Sales'].includes(ae.name)
        );
      } else if (result?.user_type == 'merchant') {
        this.menuItems = this.menuItems.filter((ae) =>
          ['PMS', 'Sales', 'Wallet', 'Webhook'].includes(ae.name)
        );
      } else {
        this.menuItems = this.menuItems.filter(
          (ae) => !['Wallet', 'Webhook'].includes(ae.name)
        );
      }
      
      this.permissionCheck = true;
    });
  }
}
